import { Component, Input } from '@angular/core';

import { BuildingBlockInterface } from '../building-block.interface';
import { ImageComponentContext } from './image-context.interface';

@Component({
    selector: 'app-image',
    templateUrl: './image.component.html',
    styleUrls: ['./image.component.min.css'],
})
export class ImageComponent implements BuildingBlockInterface {
    @Input() public context: ImageComponentContext;
    public paddingEnabled = false;
}



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/building-blocks/image/image.component.ts